import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { TailSpin } from 'react-loader-spinner';

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="right">{row.date_created}</TableCell>
        <TableCell align="right">{row.paid}</TableCell>
        <TableCell align="right">{row.total_conversion}</TableCell>
        <TableCell align="right">{row.rejected}</TableCell>
        <TableCell align="right">{row.incomplete}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>User Id</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Product</TableCell>
                    <TableCell>LeadID</TableCell>
                    <TableCell align="right">Status</TableCell>
                    <TableCell align="right">Due (INR)</TableCell>
                    <TableCell align="right">Paid (INR)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.details.map((detailsRow) => (
                    <TableRow key={detailsRow.user_id?.id}>
                      <TableCell component="th" scope="row">
                        {detailsRow.user_id?.user_id}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {detailsRow.user_id?.name}
                      </TableCell>
                      <TableCell>{detailsRow.product_id.title}</TableCell>
                      <TableCell>{detailsRow.leads.id}</TableCell>
                      <TableCell align="right">{detailsRow.status}</TableCell>
                      <TableCell align="right">{detailsRow?.due_amount}</TableCell>
                      <TableCell align="right">{detailsRow?.paid_amount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleTable({ details, loader }) {
  // React.useMemo(() => {
  //   if (search) {
  //     let filtered = details.filter((i) =>
  //       i.details.some((j) =>
  //         utils.generate_regex(search).test(j?.product_id && j.product_id?.title.toLowerCase()),
  //       ),
  //     );
  //     setDetails(filtered);
  //     setParsedData(filtered);
  //   }
  // }, [search]);
  return (
    <TableContainer component={Paper}>
    {loader ? (
      <Stack
          justifyContent={'center'}
          alignItems={'center'}
          sx={{ width: '75vw', height: '55vh' }}
        >
          <TailSpin height={45} width={45} style={{ margin: 'auto', bg: '#444' }} />
        </Stack>
    ):(
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Reports</TableCell>
            <TableCell align="right">Created On</TableCell>
            <TableCell align="right">Paid (INR)</TableCell>
            <TableCell align="right">Total Conversion</TableCell>
            <TableCell align="right">Rejected</TableCell>
            <TableCell align="right">Incomplete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            details && details.length ? (
              details.map((row) => <Row key={row.id} row={row} />)
            ) : (
              <center>No Data</center>
            )
          }
        </TableBody>
      </Table>
        )
        
        
      }
    </TableContainer>
  );
}
